import createReducer from '../config/create_reducer';
import Const from '../config/const';

const defaultState = {
  showNavigationStackBar: false,
  screenStack: {},
  smartBannerVisible: false,
  needPresent: true,
  newToPG: false,
  seoData: {},
  appLoaded: false,
  anonymousUser: null,
  loading: false,
  dbSubscribedAdvisors: [],
  forceLogout: false,
  dynamicConfig: { fxRate: 1.0 },
  googleConfig: null,
  badgeCounter: 0,
  analytics: {
    eventProps: {}
  }
};

const updateScreenStack = (screenStack, pathData) => {
  const screenStackKeys = Object.keys(screenStack);
  const pathDataKeys = Object.keys(pathData);

  if (pathDataKeys.length === 0) return pathData;
  const lastActualScreenStackKey = screenStackKeys.find(
    (key) => key === pathDataKeys[0] || (screenStack[key] && pathData[pathDataKeys[0]] && screenStack[key].type === pathData[pathDataKeys[0]].type)
  );
  if (lastActualScreenStackKey) {
    screenStackKeys.splice(screenStackKeys.indexOf(lastActualScreenStackKey));
    let updatedScreenStack = {};
    screenStackKeys.forEach((key) => {
      updatedScreenStack = { ...updatedScreenStack, [key]: screenStack[key] };
    });
    const newPathData = pathData[lastActualScreenStackKey]
      ? {
        [lastActualScreenStackKey]: {
          ...screenStack[lastActualScreenStackKey],
          ...pathData[lastActualScreenStackKey]
        }
      } : pathData;
    updatedScreenStack = { ...updatedScreenStack, ...newPathData };
    return { ...updatedScreenStack };
  }
  return { ...screenStack, ...pathData };
};

const handler = {
  [Const.application.updateNavigationStack]: (state, {
    showNavigationStackBar, pathData, navigationStackLoading
  }) => ({
    ...state,
    showNavigationStackBar,
    screenStack: updateScreenStack(state.screenStack, pathData),
    navigationStackLoading: navigationStackLoading !== undefined
      ? navigationStackLoading : state.navigationStackLoading
  }),
  [Const.application.navigationStackLoading]: (state) => ({
    ...state,
    navigationStackLoading: true
  }),
  [Const.application.clearNavigationStack]: (state) => ({
    ...state,
    showNavigationStackBar: false,
    screenStack: {}
  }),
  [Const.application.updateSmartBannerVisibility]: (state, { visible, needPresent }) => ({
    ...state,
    needPresent,
    smartBannerVisible: needPresent ? visible : false
  }),
  [Const.application.setNewToPG]: (state, { value }) => ({
    ...state,
    newToPG: value
  }),
  [Const.application.udpateSEOData]: (state, { route, seoData }) => ({
    ...state,
    seoData: {
      ...state.seoData,
      [route]: {
        ...state.seoData[route] || {},
        ...seoData
      }
    }
  }),
  [Const.application.appLoading]: (state) => ({
    ...state,
    appLoaded: true
  }),
  [Const.application.setAnonymousUser]: (state, { anonymousUser }) => ({
    ...state,
    anonymousUser
  }),
  [Const.application.dbSubscribedAdvisors]: (state, { advisorId }) => ({
    ...state,
    dbSubscribedAdvisors: [...state.dbSubscribedAdvisors, advisorId]
  }),
  [Const.application.clearDBSubscribedAdvisors]: (state) => ({
    ...state,
    dbSubscribedAdvisors: []
  }),
  [Const.application.setDynamicConfig]: (state, { dynamicConfig }) => ({
    ...state,
    dynamicConfig
  }),
  [Const.application.clearPromoCode]: (state) => ({
    ...state,
    dynamicConfig: {
      ...state.dynamicConfig,
      promo: ''
    }
  }),
  [Const.application.forceLogout]: (state, { shouldLogout }) => ({
    ...state,
    forceLogout: shouldLogout
  }),
  [Const.application.setGoogleConfig]: (state, { googleConfig }) => ({
    ...state,
    googleConfig
  }),
  [Const.application.setBadgeCounter]: (state, { badgeCounter }) => ({
    ...state,
    badgeCounter
  }),
  [Const.application.addParamsToAnalitycs]: (state, { analyticsData }) => ({
    ...state,
    analytics: {
      ...state.analytics,
      eventProps: {
        ...state.analytics.eventProps,
        ...analyticsData
      }
    }
  }),
  [Const.application.updateCurrency]: (state, { currency }) => ({
    ...state,
    dynamicConfig: {
      ...state.dynamicConfig,
      currency
    }
  }),

  [Const.application.updateFxRate]: (state, { fxRate }) => ({
    ...state,
    dynamicConfig: {
      ...state.dynamicConfig,
      fxRate
    }
  })

};

export default createReducer(defaultState, handler);
